/**
 * API Module - Exports API client and factory
 */

import { IAPIClient, RealAPIClient } from './client';
import { createMockAPIClient } from './mock';

export * from './types';
export * from './contracts';
export * from './client';
export * from './mock';

let sharedClient: IAPIClient | null = null;

/**
 * Create (or reuse) the shared API client instance.
 *
 * The client holds auth state (the bearer token) as an instance field, so
 * every caller must share the same instance - otherwise a token set via one
 * instance (e.g. after login) is invisible to requests made through another
 * instance, and those requests get silently sent unauthenticated.
 *
 * Respects REACT_APP_USE_MOCK_API environment variable.
 */
export function createAPIClient(forceReal = false): IAPIClient {
  if (sharedClient) {
    return sharedClient;
  }

  const useMock = !forceReal && process.env.REACT_APP_USE_MOCK_API === 'true';

  if (useMock) {
    console.log('[API] Using mock API client');
    sharedClient = createMockAPIClient();
    return sharedClient;
  }

  const baseURL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
  console.log('[API] Using real API client:', baseURL);
  sharedClient = new RealAPIClient(baseURL);
  return sharedClient;
}

/**
 * Create mock API client explicitly
 */
export function createMockClient(): IAPIClient {
  return createMockAPIClient();
}

/**
 * Create real API client explicitly
 */
export function createRealClient(baseURL?: string): IAPIClient {
  return new RealAPIClient(baseURL);
}
